import React, { useState, useEffect } from "react";
import FlexBetween from "components/FlexBetween";
import Header from "components/Header";
import {
  Box,  
  useTheme,
  useMediaQuery,
} from "@mui/material";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import { DataGrid,  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarDensitySelector } from "@mui/x-data-grid";
import { useApolloClient } from "@apollo/client";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ModalUtil from "components/ModalUtil";
import Alerts from "components/Alerts";
import { useLocation } from "react-router-dom";
import { useSettings } from "hooks/useSettings";
import AssignPersonalRequeriment from "./AssignPersonalRequeriment";
import { GET_ALL_PERSONAL_REQUERIMENT } from "./../../gestionpersonal/requerimentPersonal/QueryPersonalRequeriment";
import ViewRequeriment from "scenes/gestionpersonal/requerimentPersonal/ViewRequeriment";
const Personal = () => {
  const theme = useTheme();
  const location = useLocation();
  const client = useApolloClient();
  const [modalOpen, setModalOpen] = useState(false);
  const [requerimentselected, setrequerimentselected] = useState(null);
  const isNonMediumScreens = useMediaQuery("(min-width: 1200px)");
  const { currency } = useSettings();
  const [newAssignRequeriment, setNewAssignRequeriment] = useState(false);
  const [requeriment, setrequeriment] = useState([]);
  const [modalOpenView, setModalOpenView] = useState(false);
  const [alertCustom, setAlertCustom] = useState({
    type: "success",
    message: "",
    state: false,
  });
  const handleOpenModal = (id) => {
    setModalOpen(true);
    setrequerimentselected(id);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };
  const handleOpenModalView = (id) => {
    setModalOpenView(true);
    setrequerimentselected(id);
  };

  const handleCloseModalView = () => {
    setModalOpenView(false);
  };
  const columnsRequeriment = [
    {
      field: "N",
      headerName: "#",
      with: "5px",
      renderCell: (index) => index.api.getRowIndex(index.row.id) + 1,
    },
    {
      field: "state",
      headerName: "ESTADO",
      flex: 1,
      renderCell: (params) => params.row.state.description,
    },
    {
      field: "ngoal",
      headerName: "VACANTES",
      flex: 1,
      renderCell: (params) => params.row.ngoal,
    },
    {
      field: "area",
      headerName: "AREA",
      flex: 1,
      renderCell: (params) => params.row.area.description,
    },
    {
      field: "remuneration",
      headerName: "REMUNERACION",
      flex: 1,
      renderCell: (params) => currency+" " + params.row.remuneration,
    },
    {
      field: "ope",
      headerName: "",
      align: "center",
      renderCell: (params) => (
        <Box display={"flex"} gap={"5px"}>
           <VisibilityIcon onClick={() => handleOpenModalView(params.row.id)} />
          <TouchAppIcon onClick={() => handleOpenModal(params.row.id)} />
          {/* <CreateIcon />
          <DeleteIcon /> */}
        </Box>
      ),
    },
  ];
  useEffect(() => {
    const FUNCTION_GET_PERSONAL_REQUERIMENT = async () => {
      try {
        const { data } = await client.query({
          query: GET_ALL_PERSONAL_REQUERIMENT,
          fetchPolicy: "network-only",
          variables: {
            acro: location.pathname?.split("/")[1],
          }
        });
        console.log(data);
        setrequeriment(data.getPersonalRequeriment);
      } catch (error) {
        console.log(error.message);
      }
    };

    FUNCTION_GET_PERSONAL_REQUERIMENT();
  }, [newAssignRequeriment]);
  return (
    <>
     {alertCustom.state && (
        <Alerts alert={alertCustom} setAlertCustom={setAlertCustom}></Alerts>
      )}
      {" "}
      <ModalUtil
        isOpen={modalOpen}
        onClose={handleCloseModal}
        Component={AssignPersonalRequeriment}
        params={
          new Object({
            setAlertCustom: setAlertCustom,
            alertCustom: alertCustom,
            setNewAssignRequeriment: setNewAssignRequeriment,
            handleCloseModal: handleCloseModal,
          })
        }
        id={requerimentselected}
      ></ModalUtil>
         <ModalUtil
        isOpen={modalOpenView}
        onClose={handleCloseModalView}
        Component={ViewRequeriment}
        params={
          new Object({
            setAlertCustom: setAlertCustom,
            alertCustom: alertCustom,
            setNewAssignRequeriment: null,
            handleCloseModal: handleCloseModalView,
          })
        }
        id={requerimentselected}
      ></ModalUtil>
      <Box m="1.5rem 2.5rem">
        <FlexBetween>
        <Header title="ADMINISTRACION" subtitle="admin/personal" />
        </FlexBetween>
        <Box
          mt="20px"
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          gridAutoRows="160px"
          gap="20px"
          sx={{
            "& > div": {
              gridColumn: isNonMediumScreens ? undefined : "span 12",
            },
          }}
        >      
          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={theme.palette.background.alt}
            p="1rem"
            borderRadius="0.55rem"
            sx={{
              "& .MuiDataGrid-root": {
                border: "none",
                borderRadius: "5rem",
              },
              "& .MuiDataGrid-cell": {
                borderBottom: "none",
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: theme.palette.background.alt,
                color: theme.palette.secondary[100],
                borderBottom: "none",
              },
              "& .MuiDataGrid-virtualScroller": {
                backgroundColor: theme.palette.background.alt,
              },
              "& .MuiDataGrid-footerContainer": {
                backgroundColor: theme.palette.background.alt,
                color: theme.palette.secondary[100],
                borderTop: "none",
              },
              "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                color: `${theme.palette.secondary[200]} !important`,
              },
            }}
          >
            <Box fontSize={"12px"} fontWeight={"700"} textAlign={"center"}>
              HISTORIAL DE REQUERIMIENTOS
            </Box>
            <DataGrid
              loading={!requeriment}
              getRowId={(row) => row.id}
              rows={
                requeriment?.filter(
                  (row) => row.state.description === "PENDIENTE"
                ) || []
              }
              columns={columnsRequeriment}
              components={{
                Toolbar: () => <GridToolbarContainer>
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
              </GridToolbarContainer>,
              }}
            />
          </Box>

          {/*   <StatBox
        icon={
          <Traffic
            sx={{ color: theme.palette.secondary[300], fontSize: "26px" }}
          />
        }
      />
      <StatBox
        icon={
          <PersonAdd
            sx={{ color: theme.palette.secondary[300], fontSize: "26px" }}
          />
        }
      /> */}
          {/* ROW 2 */}
        </Box>
      </Box>
    </>
  );
};

export default Personal;
